import { Component, OnInit,Input } from '@angular/core';
import { GlobalService } from '@common/global';
import { FormGroup ,FormControl} from '@angular/forms';
@Component({
  selector: 'app-ui-app-search-list',
  templateUrl: './ui-app-search-list.component.html',
  styleUrls: ['./ui-app-search-list.component.sass']
})
export class UiAppSearchListComponent implements OnInit {
  @Input('a') application: string;
  @Input('c') component: string;
  @Input('listName') listName: string;
  @Input('className') className: string;
  @Input('response') res: object;
  @Input('page') page: object;
  @Input('controlName') controlName: number;
  @Input('formGroup') formGroup = new FormGroup({
  });
  isLogin=false;
  is_owner=false;
  constructor(private _global: GlobalService) { }

  ngOnInit(): void {
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
      this.is_owner = this._global.isOwner(this._global.getVal(this.res, 'createdBy', ''));
    }
  }

}
